<template>
  <div class="wall-profile-section">
    <div class="card wall-profile-card mb-3">
      <div class="card-body text-center">
        <div class="avatar-parent-child">
          <UserProfileAvatar
            :name="[currentUser?.name, currentUser?.surname].filter(Boolean).join(' ')"
            :photo="currentUser?.photo_link"
            class="wall-profile-avatar"
          />
          <span class="avatar-child avatar-badge bg-success"></span>
        </div>
        <h5 class="h6 mt-4 mb-0">
          {{ currentUser.name + " " + currentUser.surname }}
        </h5>
        <p class="d-block text-sm text-muted">@{{ currentUser.name }}.{{ currentUser.surname }}</p>
      </div>
    </div>

    <div class="card wall-latest-card">
      <div class="card-header">
        <h4 class="h6 mb-0">
          <i class="uil uil-share-alt"></i> {{ $t("general.last_actions") }}
        </h4>
      </div>
      <div class="card-body wall-latest-body">
        <ul class="wall-latest-list">
          <li v-for="(action, aIndex) in latestActions" :key="action.id || aIndex"
              class="wall-latest-item">
            <span v-html="action.message"></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import UserProfileAvatar from "@/view/components/common/UserProfileAvatar.vue";

export default {
  name: "WallProfileSection",
  components: {
    UserProfileAvatar,
  },
  props: {
    currentUser: {
      type: Object,
      required: true,
    },
    latestActions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.wall-profile-card,
.wall-latest-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
  background: #ffffff;
  overflow: hidden;
}

.wall-profile-card:hover,
.wall-latest-card:hover {
  box-shadow: none !important;
  transform: none;
}

.wall-latest-body {
  max-height: 300px;
  overflow-y: auto;
  padding: 12px;
}

.wall-latest-list {
  list-style: none;
  padding-left: 0 !important;
  margin: 0;
}

.wall-latest-item {
  font-size: 13px;
  color: #666666;
  padding: 8px 0;
  line-height: 1.5;
  border-bottom: 1px solid #f3f2ef;
}

.wall-latest-item:last-child {
  border-bottom: none;
}

.wall-profile-avatar {
  width: 40px;
  height: 40px;
  min-width: 40px;
  font-size: 13px;
}

.avatar-parent-child .avatar-child {
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
</style>
